import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListComponent } from './list/list.component';
import { AddComponent } from './add/add.component';
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';
import { ClassTemplateListComponent } from './class-template-list/class-template-list.component';
import { AddUpdateClasstemplateComponent } from './add-update-classtemplate/add-update-classtemplate.component';
import { AddUpdateClassbystudentComponent } from './add-update-classbystudent/add-update-classbystudent.component';
import { AddUpdateClassbybatchComponent } from './add-update-classbybatch/add-update-classbybatch.component';

const routes: Routes = [
  {
    path:'list', component:ListComponent,
    canActivate: [PermissionGuard],
    data: { roles: ['admin','Managment','Training Moderator','Teacher'] } 
  },
  {
    path:'add', component:AddComponent
  },
  {
    path:'edit/:id', component:AddComponent
  },
  {
    path:'sessions', component:ClassTemplateListComponent,
  },
  {
    path:'add-edit-session', component:AddUpdateClasstemplateComponent,
  },
  {
    path:'add-update-class-byStduent', component:AddUpdateClassbystudentComponent,
  },
  {
    path:'add-update-class-byStduent/:id', component:AddUpdateClassbystudentComponent,
  },
  {
    path:'add-update-class-byBatch', component:AddUpdateClassbybatchComponent,
  },
  {
    path:'add-update-class-byBatch/:id', component:AddUpdateClassbybatchComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClassesRoutingModule { }
